import { ButtonType, ButtonWidget } from '@tableau/widgets';
import { ArrayRowStore, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { PlainTextCell } from '~src/spacesPlatform/components/ListView/dataGridCells/PlainTextAndNumberCells';
import { SortableHeader } from '~src/spacesPlatform/components/ListView/SortableHeader';

import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from './ActionMessages';

export type ActionFailureDetailsDialogContentProps = {
  closeDialog: () => void;
  errorDetails: ReadonlyArray<IErrorDetail>;
};

function buildDataGridProps(errorDetails: ReadonlyArray<IErrorDetail>): DataGrid.Props {

  const headerFormatter = SortableHeader.Formatter([], () => {});

  const cols: DataGrid.Column[] = [
    {
      name: 'itemName-col',
      dataKey: 'itemName',
      headerText: Messages.column_error_item_name(),
      sortable: false,
      headerFormatter,
      cellFormatter: React.createFactory(PlainTextCell('itemName')),
    },
    {
      name: 'errorMessage-col',
      dataKey: 'errorMessage',
      headerText: Messages.column_error_message(),
      sortable: false,
      headerFormatter,
      cellFormatter: React.createFactory(PlainTextCell('errorMessage')),
    }
  ];

  return {
    cols,
    rowStore: new ArrayRowStore(errorDetails.map(
      (e) => ({ data: e, key: e.itemName })
    )),
  };
}

export function ActionFailureDetailsDialogContent(props: ActionFailureDetailsDialogContentProps) {

  const dataGridProps: DataGrid.Props = React.useMemo(
    () => buildDataGridProps(props.errorDetails),
    [props.errorDetails]
  );

  const buttonRef = React.useRef<HTMLButtonElement>();
  React.useLayoutEffect(
    () => buttonRef.current.focus(),
    []
  );

  return (
    <div className="tb-error-details-dialog">
      <div style={{ position: 'relative', height: 300 }}>
        <DataGrid {...dataGridProps} />
      </div>

      <div className="tb-dialog-actions">
        <ButtonWidget
          buttonRef={buttonRef}
          buttonType={ButtonType.Outline}
          onClick={props.closeDialog}
          testId="ErrorDetailsCloseButton"
        >
          { Messages.dismiss() }
        </ButtonWidget>

      </div>
    </div>
  );
}
